import http from "../http-common";

class FastQuotingDoorDataService {
  getAll() {
    return http.get("/fastquotingdoor");
  }

  // not ready yet
  getAllMultipleConditions(data) {
    return http.post("/fastquotingdoor/findbymultipleconditions",data);
  }

  getfastquotingdoorByDescr(condition, sortfield,sorttype) {
    return http.get(`/fastquotingdoor/search/?fastquotingdoornumber=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  getCondition(condition) {
    return http.get(`/fastquotingdoor/search/?type=${condition}`);
  }

  getMaxId() {
    return http.get(`/fastquotingdoor/vals/maxid`);
  }

  get(id) {
    return http.get(`/fastquotingdoor/get/${id}`);
  }

  create(data) {
    return http.post("/fastquotingdoor", data);
  }

  update(id, data) {
    return http.put(`/fastquotingdoor/update/${id}`, data);
  }

  delete(id) {
    return http.delete(`/fastquotingdoor/${id}`);
  }

  deleteAll() {
    return http.delete(`/fastquotingdoor`);
  }

  findById(id) {
    return http.get(`/fastquotingdoor/get/${id}`);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////

}

export default new FastQuotingDoorDataService();

// for req.query:
// use params in Postman, 
//path without /:"param" in the backend and 
//path with /?"parameter"="valueparameter" in the front end